<template>
  <div class="px-4 py-2">
    <b-button variant="primary" @click="chatVisible = !chatVisible" class="enterprise-button" :disabled="loading">
      <b-icon icon="chat"></b-icon>
    </b-button>

    <div v-show="chatVisible" class="chat-wrapper">
      <div ref="chatWindowContainer" class="chat-window" style="height: 600px;"></div>
      <button class="chat-close" @click="closeChat" aria-label="Chiudi chat">×</button>
    </div>
  </div>
</template>

<script>
import { AxertaChat } from "@/utils/axerta";
import AxiosService from "../../axiosServices/AxiosService";

export default {
  name: "TALKJS-BUTTON",

  data() {
    return {
      loading: true,
      chatVisible: false,
      session: null,
      me: null,
    };
  },

  computed: {
    conversations() {
      return this.$store.getters.conversations;
    },
    inbox() {
      return this.$store.getters.inbox;
    },
  },
  watch: {
    conversations: {
      handler: function () {
        this.buildInbox();
      },
    },
    inbox: {
      handler: function () {
        this.buildInbox();
      },
    },
  },

  mounted() {
    setTimeout(async () => {
      await this.$nextTick();
      await this.handleCreationTalkjsSession();
      await this.buildInbox();

      this.loading = false;
    }, 1200);
  },

  methods: {
    async buildInbox() {
      if (this.inbox) {
        this.inbox.mount(this.$refs.chatWindowContainer);
        return;
      }

      const conversations = this.$store.getters.conversations || [];

      // On small screens we want the conversation pane visible by default.
      const isSmall = typeof window !== 'undefined' && window.innerWidth <= 768;

      const inboxOptions = { showMessageActions: true };
      if (isSmall && conversations.length) {
        // select the first conversation so the conversation panel opens on mobile
        inboxOptions.selected = conversations[0];
      }

      const inbox = await this.session.createInbox(inboxOptions);

      // Ensure at least the first conversation is selected so the conversation pane opens.
      if (conversations.length) {
        try {
          inbox.select(conversations[0]);
        } catch (err) {
          // fallback: if select fails, still mount the inbox
          console.warn("Could not auto-select conversation:", err);
        }
      }

      inbox.mount(this.$refs.chatWindowContainer);

      inbox.onCustomMessageAction("important", (event) => this.setMessageImportance(event, "1"))
      inbox.onCustomMessageAction("unimportant", (event) => this.setMessageImportance(event, "0"))
    },
    async setMessageImportance(event, isImportant) {
      const id_conversation = event.message.conversation.id;
      const id_message = event.message.id;
      const service = new AxiosService();

      try {
        await service.putCustomEndpoint(`DossierManager/SetImportantMessagesTkjs/${id_conversation}/${id_message}/${isImportant}`);
      } catch (err) {
        console.error(err);
      }
    },

    async handleCreationTalkjsSession() {
      const loggedBo = this.$store.getters.loggedUser;
      const company = this.$store.getters.company;
      try {
        const boUser = {
          id: company.nome + "_BO_" + loggedBo.id,
          fullname: loggedBo.nome + " " + loggedBo.cognome,
          email: loggedBo.email,
          avatar_url:
            loggedBo.avatar_url ||
            "https://avatar.iran.liara.run/public/" + loggedBo.id,
          welcomeMessage: "Ciao! Sto aspettando il tuo messaggio.",
          role: "BO",
        };

        const session = await AxertaChat.createSession("tjBGvoRX", boUser);

        this.session = session;
      } catch (error) {
        console.error("Errore nella creazione della sessione TalkJS:", error);
      }
    },
    closeChat() {
      this.chatVisible = false;
    },
  },
};
</script>

<style scoped>
.enterprise-button {
  width: 60px;
  height: 60px;
  background-color: var(--primary);
  color: var(--light);
  border: 2px solid var(--light);
  border-radius: 50%;
  padding: 5px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 3000;
}

.enterprise-button:disabled {
  background-color: var(--light);
  color: var(--primary);
  border: 2px solid var(--primary);
  cursor: not-allowed;
  box-shadow: none;
}

.enterprise-button:hover:not(:disabled) {
  background-color: var(--light);
  color: var(--primary);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* wrapper controls fixed positioning; inner .chat-window is the mount target */
.chat-wrapper {
  position: fixed;
  bottom: 80px;
  right: 0;
  z-index: 2000;
  width: 750px;
  max-width: calc(100% - 20px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  border-radius: 12px 0 0 12px;
  overflow: visible;
  transition: width 200ms ease, height 200ms ease, right 200ms ease, left 200ms ease;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.chat-window {
  width: 100vw;
  height: 100%;
  background: transparent;
  border-radius: inherit;
}

@media (max-width: 1024px) {
  .chat-wrapper {
    width: 640px;
    right: 8px;
    bottom: 72px;
  }
}

@media (max-width: 768px) {
  .chat-wrapper {
    left: 10px;
    right: 10px;
    bottom: 70px;
    width: calc(100% - 20px);
    height: 60vh;
    border-radius: 0;
    background: transparent;
    padding: 0;
    overflow: visible;
  }
}

@media (max-width: 480px) {
  .chat-wrapper {
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: calc(100vh - 20px);
    border-radius: 0;
    margin: 0;
    background: transparent;
    padding: 0;
    overflow: visible;
  }
}

/* Ensure injected TalkJS elements fill the container without producing white gutters */
.chat-window,
.chat-window * {
  box-sizing: border-box;
}

.chat-window > * {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
}

/* Target common TalkJS selectors (best-effort) */
.chat-window iframe,
.chat-window .talkjs-container,
.chat-window .talkjs-inbox,
.chat-window .talkjs-popup {
  width: 100% !important;
  height: 100% !important;
  border-radius: inherit !important;
  background: transparent !important;
}

/* Close button */
.chat-close {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0,0,0,0.6);
  color: #fff;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  z-index: 3001;
}

.chat-close:focus{outline:none}

/* Reduce vertical offset on very small screens if header occupies space */
@media (max-width: 420px) {
  .chat-window {
    height: calc(100vh - 60px);
    bottom: 0;
  }
}
</style>